/*
 * Filename: index.tsx
 */

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { CQAppStore } from '../src/store/cq-app-store';
import { Provider } from 'mobx-react';

ReactDOM.render(
    <Provider store={CQAppStore}>
        <App/>
    </Provider>
    , document.getElementById('root'));
